import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders'

export function loadAssessment({ request, params }) {
  return new Promise(function(resolve, reject) {
    if (params.assessment_id == "new") {
      return resolve({});
    }

    publicAction("getAssessment", {
      id: params.assessment_id,
      course_id: params.course_id
    }).then(function({ data }) {
      if (data.value) {
        resolve({data: data});
      } else {
        reject({text: "Assessment not found", path: `/courses/${params.course_id}`, status: 404 });
      }
    }).catch(reject);
  })
}

export function loadAssessments({ request, params }) {
  return publicAction("getCourseAssessments", { id: params.course_id })
}

export function assessmentSubmitCreate({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(request_data) {

      publicAction("createAssessment", {
        ...request_data,
        course_id: params.course_id,
        scenario_id: params.scenario_id
      }).then(function({ data }) {
        if (data.share_prompt_files) {
          resolve({share_prompt_files: data.share_prompt_files, show_should_share_files_prompt: data.show_should_share_files_prompt, request_data, date: Date.now(), dont_revalidate: true});
        } else {
          resolve(redirect("/courses/"+params.course_id))
        }
      }).catch(function() {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}

export function assessmentSubmitUpdate({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(request_data) {
      
      publicAction("updateAssessment", {
        ...request_data,
        course_id: params.course_id,
        id: params.assessment_id
      }).then(function({ data }) {
        if (data.share_prompt_files) {
          resolve({share_prompt_files: data.share_prompt_files, show_should_share_files_prompt: data.show_should_share_files_prompt, request_data, date: Date.now(), dont_revalidate: true});
        } else {
          resolve({success: true, date: Date.now()});
        }
      }).catch(function() {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}

export function loadAssessmentOverview({ request, params }) {
  return new Promise(function(resolve, reject) {
    publicAction("getAssessmentOverview", {
      assessment_id: params.assessment_id,
      course_id: params.course_id
    }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else if (data.student_redirect) {
        resolve(redirect(`/courses/${params.course_id}`));
      } else {
        reject({text: "Assessment not found", path: `/courses/${params.course_id}`, status: 404 });
      }
    }).catch(reject);
  })
}

export function loadAssessmentPreviews({ request, params }) {
  return new Promise(function(resolve, reject) {
    publicAction("getAssessmentPreviews", {
      assessment_id: params.assessment_id,
      course_id: params.course_id
    }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else {
        reject({text: "Assessment not found", path: `/courses/${params.course_id}`, status: 404 });
      }
    }).catch(reject);
  })
}